import { faIcon } from "@utils/faIcon"
import formatQuantity from "@utils/formatQuantity"

import { Badge } from "@atoms"

import { DefaultTaxRateBadgeProps } from "./DefaultTaxRateBadge.types"

const icon = faIcon({ name: "tag", style: "regular" })

export default function DefaultTaxRateBadge(props: DefaultTaxRateBadgeProps) {
    const { rate, size = "md" } = props

    // The badge is always shown — a missing rate renders as "0%". Rates carry up to three decimals ("8.125"),
    // so the trailing zeros are dropped rather than the value rounded, matching the table's percentage cell.
    const formatted = `${formatQuantity(rate ?? 0)}%`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`Default tax rate\n${formatted}`}>
            {formatted}
        </Badge>
    )
}
